<div class="mix-chart-style">
  <canvas id="combinedChart" width="full" height="full"></canvas>
</div>
